import {ConFormula, PtrnCampoEditableFormula} from '../../patronTypes';
import {PtrnTransformarCampoFn} from './ptrnProcesarTypes';

export const ptrnTranformarFormula: PtrnTransformarCampoFn<
   ConFormula<any>,
   PtrnCampoEditableFormula
> = (originalValue, campoConfig, estado) => {
   let newValue: ConFormula<any> = originalValue
      ? {...originalValue}
      : {formula: '', valor: 0, valorVisible: ''};
   newValue.formula = newValue.formula.toUpperCase();
   newValue.valorVisible = newValue.valorVisible.toUpperCase();
   return newValue;
};
